import React from 'react';
import {
    PropsShell,
    PropsNotFound,
    PropsCommonFields,
    PropsSection,
    PropsField,
    PropsToggle,
    PropsRequiredAndMeta,
    useQuestionProperties,
} from './QuestionPropertiesShared';

const FILE_TYPE_OPTIONS = [
    'image/*',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/plain',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'video/*',
    'audio/*',
];

const FileUploadBlockProperties = ({ questionId }) => {
    const { question, localName, nameError, handleUpdate, handleNameChange } =
        useQuestionProperties(questionId);

    if (!question) return <PropsNotFound />;

    const accepted = Array.isArray(question.acceptedFileTypes) ? question.acceptedFileTypes : [];

    const toggleFileType = (type) => {
        const next = accepted.includes(type)
            ? accepted.filter((item) => item !== type)
            : [...accepted, type];
        handleUpdate('acceptedFileTypes', next);
    };

    return (
        <PropsShell typeLabel="File upload" typeIcon="bi-upload">
            <PropsCommonFields
                localName={localName}
                nameError={nameError}
                onNameChange={handleNameChange}
                title={question.title}
                description={question.description}
                onTitleChange={(value) => handleUpdate('title', value)}
                onDescriptionChange={(value) => handleUpdate('description', value)}
            />

            <PropsSection title="Upload rules">
                <PropsField label="Accepted file types">
                    <div className="ecx-survey-props__options">
                        {FILE_TYPE_OPTIONS.map((type) => (
                            <label key={type} className="ecx-survey-props__toggle">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={accepted.includes(type)}
                                    onChange={() => toggleFileType(type)}
                                />
                                <span className="small">{type}</span>
                            </label>
                        ))}
                    </div>
                </PropsField>

                <PropsField label="Maximum file size (MB)">
                    <input
                        type="number"
                        className="form-control form-control-sm"
                        min={1}
                        max={100}
                        value={question.maxFileSize || 5}
                        onChange={(e) =>
                            handleUpdate('maxFileSize', parseInt(e.target.value, 10) || 5)
                        }
                    />
                </PropsField>

                <PropsToggle
                    checked={question.allowMultiple}
                    onChange={(e) => handleUpdate('allowMultiple', e.target.checked)}
                    label="Allow multiple files"
                />
            </PropsSection>

            <PropsRequiredAndMeta
                required={question.required}
                onRequiredChange={(value) => handleUpdate('required', value)}
                questionId={questionId}
            />
        </PropsShell>
    );
};

export default FileUploadBlockProperties;
